<template>
    <b-overlay :show="show" @click="$emit('click')" no-wrap fixed opacity="0.70" class="d-block d-md-none">
      <template #overlay>
        <div></div>
      </template>
    </b-overlay>
</template>

<script>
export default {
  name: "Overlay",
    props: {
      show: {
        type: Boolean,
        default: false
      }
    }
}
</script>

<style scoped>

</style>